import { ContextBase, StateTransitionData, StateTypes } from "@ortho-next/nextray-core";
import { Calibrated } from "./Calibrated";
import { DeformityAnalysis } from "./DeformityAnalysis";
import { EOC } from "./EOC";
import { Loading } from "./Loading";
import { RPM } from "./RPM";
import { Actions, State } from "./State";
import { Templating } from "./Templating";

/**
 * Events dispatcher to execute events logic inside contextInit.
 */
export class Context extends ContextBase<Actions> {
	protected declare _state: State;

	protected changeState(state: StateTransitionData): State {
		switch (state.type) {
			case StateTypes.loading:
				return new Loading(this);
			case StateTypes.calibrated:
				return new Calibrated(this, state.data.caseModel, state.data.restore);
			case StateTypes.deformityAnalysis:
				return new DeformityAnalysis(this, state.data.caseModel, state.data.restore);
			case StateTypes.EOC:
				return new EOC(this, state.data.caseModel, state.data.restore);
			case StateTypes.templating:
				return new Templating(this, state.data.caseModel, state.data.restore);
			case StateTypes.RPM:
				return new RPM(this, state.data.caseModel, state.data.restore);
		}
		return this._state;
	}

	constructor() {
		super();
		this._state = new Loading(this);
	}
}
